import { Actor, Engine, Color, CollisionType, vec } from "excalibur";
import { Virus } from "../Virus";
import { Macrophage } from "../Macrophage";
import { ProjectileCollision } from "../../systems/CollisionGroups";
import { Resources } from "../../resources";

export class IgMPentamer extends Actor {
    private player: Macrophage;
    private angle: number = 0;
    private orbitSpeed: number = 2.0; // Base speed
    private orbitDistance: number = 100; // Closer to player (was 200)
    private damage: number = 25; // User requested 25 specifically or matching Antibody (25)
    private pushbackForce: number = 300;
    private onKill: (v: Virus) => void;

    constructor(player: Macrophage, angleOffset: number = 0, onKill: (v: Virus) => void) {
        super({
            name: 'IgMPentamer',
            radius: 20, // Smaller collider (was 20)
            color: Color.Transparent, // Use sprite
            collisionType: CollisionType.Active,
            collisionGroup: ProjectileCollision,
        });
        this.player = player;
        this.angle = angleOffset;
        this.onKill = onKill;
    }

    override onInitialize(engine: Engine): void {
        const sprite = Resources.Antibody.toSprite();
        // Make it smaller as requested (0.2)
        sprite.scale = vec(0.2, 0.2);
        this.graphics.use(sprite);
    }

    override onPreUpdate(engine: Engine, delta: number): void {
        // dynamic speed based on player level
        // Base unlocked at level 3. For every level above 3, increase speed.
        const levelBonus = Math.max(0, this.player.level - 3) * 0.5;
        const currentSpeed = this.orbitSpeed + levelBonus;

        // Orbit logic
        this.angle += currentSpeed * (delta / 1000);

        // Keep position relative to player
        this.pos = this.player.pos.add(vec(
            Math.cos(this.angle) * this.orbitDistance,
            Math.sin(this.angle) * this.orbitDistance
        ));

        // Spin
        this.rotation += (5 + levelBonus) * (delta / 1000);
    }

    override onCollisionStart(self: any, other: any): void {
        const hitActor = other.owner;
        if (hitActor instanceof Virus && hitActor.isPoolActive()) {
            const virus = hitActor as Virus;

            // Damage
            const killed = virus.takeDamage(this.damage);
            if (killed) {
                this.onKill(virus);
            }

            // Pushback
            const pushDir = virus.pos.sub(this.player.pos).normalize();
            virus.vel = virus.vel.add(pushDir.scale(this.pushbackForce));
        }
    }
}
